export default "__VITE_ASSET__DTyyXDe$__"